import {language} from "../enum/languages.enum";
import en from "./en";
import rus from "./ru";
import zh from "./zh";

export default {
  [language.en]: en,
  [language.ru]: rus,
  [language.zh]: zh
}
